import React, { useContext } from 'react';
import './App.css';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { AuthProvider } from './auth/Auth';
import { LoggedInRouteGuard } from './auth/guards/LoggedInRouteGuard';
// import Login from './pages/login/Login';
import { ResetPassword } from './pages/resetPassword/ResetPassword';
import { Home } from './pages/home/Home';
import { ToastsPortal, Typography } from '@hiiretail/synergy-ui';
import { GlobalFeatureFlagsContext } from 'providers/GlobalFeatureFlagsContext/GlobalFeatureFlagsContext';
import { Box, CircularProgress } from '@material-ui/core';

export const App: React.FC = () => {
  const { isReady, firebaseConfig } = useContext(GlobalFeatureFlagsContext);

  const theme = createTheme({
    palette: {
      primary: {
        100: '#d8d6e0',
        300: '#8a85a2',
        500: '#3c3364',
        700: '#302950',
        900: '#241f3c',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      {isReady ? (
        <AuthProvider firebaseConfig={firebaseConfig}>
          <Router>
            <Typography variant="body2">
              <ToastsPortal />
              <LoggedInRouteGuard exact path="/" component={Home} />
              {/* Login is disabled in PBR version, since it's handled by separate login application */}
              {/* <Route exact path="/login" component={Login} /> */}
              <Route exact path="/reset-password" component={ResetPassword} />
            </Typography>
          </Router>
        </AuthProvider>
      ) : (
        <Box display="flex" height="100%" width="100%" alignItems="center" justifyContent="center">
          <CircularProgress size="5rem" />
        </Box>
      )}
    </ThemeProvider>
  );
};
